module.exports = __webpack_public_path__ + "static/media/image4.fb87f5de.png";